import React from 'react'
import { routes } from '../../../../constants/routes.constants'
import './fixed-float-button-styles'

const { BRAND } = process.env.ENV_VALUES

const FixedFloatButton = () => {
	const handleClick = link => {
		window.location.href = link
	}

	const WHATSAPP_IMAGE_FLOAT = require('../../../../../assets/images/whatsapp-float/whats.svg')
	const FALE_CONOSCO_IMAGE_FLOAT = require(`../../../../../assets/images/fale-conosco-float/${BRAND}/fale_conosco.svg`)

	const btns = [
		{ imageSource: WHATSAPP_IMAGE_FLOAT, link: routes.WHATSAPP },
		{ imageSource: FALE_CONOSCO_IMAGE_FLOAT, link: routes.ATENDIMENTO }
	]

	return (
		<div className="fixed-float-button-container">
			{btns.map(btn => (
				<button onClick={() => handleClick(btn.link)}>
					<img src={btn.imageSource} />
				</button>
			))}
		</div>
	)
}

export default FixedFloatButton
